import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link, useHistory } from "react-router-dom"
import { useLocation, useParams } from "react-router"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "./table/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import imageBaseUrl from "../../../helpers/imageBaseUrl"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Pdf_Icon from '../../../assets/images/PDF_file_icon.png'

import {
  Ceremony,
  Name,
  VendorType,
  Unit,
  Value
} from "./Vendor_pricingListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Card,
  CardBody,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import { addNewVendor_pricing, deleteVendor_pricing, getVendor_pricing, updateVendor_pricing } from "../../../store/vendor_pricing/actions"


function VendorPricingList() {
  const history = useHistory()
  const params = useParams()
  const location = useLocation()


  const [vendor, setVendor] = useState([])
  const [selectedFiles, setselectedFiles] = useState([])
  const [offset,setOffset]=useState(0)
  const [page_size, setPageSize] = useState(10)
  const [toggle,setToggle] = useState(false)
  const dispatch = useDispatch()
  const pricing = useSelector(state => state.vendors.vendor_pricing.data)
  const loading = useSelector(state => state.vendors.vendor_pricing.loading)
  const total_page = useSelector(state => state.vendors.vendor_pricing.total_page)
  const [haveMax,setHaveMax] = useState(false)


  useEffect(() => {
    
    // if (vendors && !vendors.length) {
    dispatch(getVendor_pricing({id:params.vendor_id,offset,page_size}))
    // }
  }, [dispatch,offset,page_size])




  //delete vendor
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = vendor => {
    setVendor(vendor)
    setDeleteModal(true)
  }

 const updatePricing = (v) => {
  setToggle(true)
setVendor(v)
 }

  const handleDeleteUser = () => {

    if (vendor.id) {
      dispatch(deleteVendor_pricing(vendor))
      setDeleteModal(false)
    }
  }
  useEffect(() => {
    if (!loading) {
      setDeleteModal(false)
    }
  }, [loading])
  const handleUserClicks = () => {
    history.push( 
      {
      pathname:"/vendor-pricing/add",
      state:{types:location?.state?.types}
      })
  }

  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Image",

        filterable: true,
        disableFilters: true,
        accessor: cellProps => (
          <React.Fragment>
            {!cellProps.image ? (
              <div className="avatar-lg d-inline-block me-2">
                <div className="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i className="mdi mdi-account-circle m-0"></i>
                </div>
              </div>
            ) : cellProps?.image?.split('.').pop() == 'pdf' ?  <img
            onClick={()=>window.open(imageBaseUrl+cellProps?.image, "_blank", "noreferrer")}
            className="avatar-lg rounded-circle me-2"
            src={Pdf_Icon}
            alt=""
          />
         : (
              <>
                <img
                  className="avatar-lg rounded-circle me-2"
                  src={imageBaseUrl + cellProps?.image}
                  alt=""
                />
              </>
            )}
          </React.Fragment>
        ),
      },
      {
        Header: "Name",
        accessor: "name",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />
        },
      },
      // {
      //   Header: "Vendor Type",
      //   accessor: "vendor_cat_name",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <VendorType {...cellProps} />
      //   },
      // },
      {
        Header: "Ceremony",
        accessor: "ceremony_name",
        filterable: true,
        Cell: cellProps => {
          return <Ceremony {...cellProps} />
        },
      },
      // {
      //   Header: "Unit",
      //   accessor: "unit",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <Unit {...cellProps} />
      //   },
      // },
      {
        Header: "Unit of measure",
        accessor: "unit_of_major",
        filterable: true,
        Cell: cellProps => {
          return <Unit {...cellProps} />
        },
      },
      {
        Header: "Unit of measure defined",
        accessor: "unit_of_measur_name",
        filterable: true,
        Cell: cellProps => {
          return <Unit {...cellProps} />
        },
      },
      // {
      //   Header: "Value",
      //   accessor: "value",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <Value {...cellProps} />
      //   },
      // },
      {
        Header:haveMax ? "min price" : 'price',
        accessor: "value", 
        filterable: true,
        Cell: cellProps => {
          return <Value {...cellProps} />
        },
      },
      {
        Header: "Has Range",
        accessor: "is_range",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={true}
                // onClick={e =>
                //   dispatch(
                //     updateVendor_pricing({
                //       is_active: 0,
                //       id: cellProps.row.original.id,
                //     })
                //   )
                // }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                defaultChecked={true}
              />
            ) : (
              <input
                disabled={true}
                // onClick={e =>
                //   dispatch(
                //     updateVendor_pricing({
                //       is_active: 1,
                //       id: cellProps.row.original.id,
                //     })
                //   )
                // }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                defaultChecked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Max price",
        accessor: "max_value",
        filterable: true,
        Cell: cellProps => {
          return <Value {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor_pricing({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                defaultChecked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor_pricing({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                defaultChecked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    onClick={()=>updatePricing(cellProps.row.original)}
                    className="text-primary"
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    // to="#"
                    className="text-danger"
                    onClick={() => {
                      const vendors = cellProps.row.original
                      onClickDelete(vendors)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() =>
                          history.push(
                            `/vendor/media/${cellProps.row.original.id}`,
                            { vendor_name: cellProps.row.original.name }
                          )
                        }
                      >
                        Show media
                      </DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [haveMax,pricing]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="MENU"
            breadcrumbItem={location?.state?.vendor_name}
          />
          <Row>
            <Col xs="12">
              <Card>

                <CardBody>
                  
                  <TableContainer
                  toggle={toggle}
                  setToggle={setToggle}
                    vendor={vendor}
                    offset={offset}
                    columns={columns}
                    data={pricing}
                    isGlobalFilter={true}
                    isAddUsers={false}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                    setHaveMax={setHaveMax}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
VendorPricingList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default VendorPricingList
